import { Stack, StackItem } from "@fluentui/react";
import { Breadcrumb, BreadcrumbItem, BreadcrumbDivider, BreadcrumbButton } from "@fluentui/react-breadcrumb-preview";
import { Body1Strong, FluentProvider, Text } from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";
import { breadcrumbTheme } from "../../styles/customStyles";

interface iBreadcrumbLevel {
  name: string;
  link: string;
  isData?: boolean; // Flag to identify if this is data from table
  canNavigate?: boolean; // Flag to control if item should navigate
}

interface iBreadcrumbsProps {
  items?: iBreadcrumbLevel[];
  pageName?: string;
  subPageName?: string;
  subPageLink?: string;
}

export const Breadcrumbs = ({ items }: iBreadcrumbsProps) => {
  const navigate = useNavigate();
  const handleNavigation = ({ canNavigate, link }: iBreadcrumbLevel) => canNavigate !== false ? navigate(link) : null;
  return (
    <FluentProvider theme={breadcrumbTheme}>
      <Stack horizontal tokens={{ childrenGap: 3 }}>
        <Text />
        <Breadcrumb size="small">
          {items?.map((item, index) => (
            <BreadcrumbItem key={index}>
              <BreadcrumbButton onClick={() => handleNavigation(item)}>
                <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }}>
                  <Body1Strong> {item.name} </Body1Strong>
                  <StackItem style={{ height: "10px" }} align="center">
                    {index < items.length - 1 && <BreadcrumbDivider style={{ color: "#EF5E03" }} />}
                  </StackItem>
                </Stack>
              </BreadcrumbButton>
            </BreadcrumbItem>
          ))}
        </Breadcrumb>
      </Stack>
    </FluentProvider>
  );
};
